import molecules from "../../../../molecules";
import { AddStorePermissionProps, BasicPermissionType, StructuredPermissionType } from "./interface";

const { CheckboxDropdown } = molecules;

const AddStorePermission: React.FC<AddStorePermissionProps> = ({
  defaultPermission,
  structuredPermission,
  setStoreDetails,
  setDefaultPermission,
  permissionHeading,
  permissionKey
}): JSX.Element => {

  const _handleCheckboxChange = (codeArr: string[]) => {
    setStoreDetails((prevState: any) => ({
      ...prevState,
      [permissionKey]: codeArr,
    }));
    
    handleAddDefaultPermission(codeArr)
  };

  // end

  // function to add the default permission
  const extractAllPermCodes = (permissions: StructuredPermissionType[] | undefined, selectedCode: string[]): BasicPermissionType[] => {
    const result: BasicPermissionType[] = [];

    // Recursive helper function to walk through each permission item
    const traverse = (items: StructuredPermissionType[]) => {
      // Safety check to prevent runtime errors
      if (!Array.isArray(items)) return;

      for (const item of items) {
        if (selectedCode.includes(item.perm_code)) {
          // Collect the current item's perm_code
          const { child, ...flattenedPermission } = item;
          result.push(flattenedPermission);
        }
        // Recursively process children, if they exist
        if (Array.isArray(item.child) && item.child.length > 0) {
          traverse(item.child);
        }
      }
    };

    // Kick off the recursion with provided permissions
    traverse(permissions || []);
    return result;
  };
  // end

  // INFO:- function to data the permission in default permissions
  const handleAddDefaultPermission = (codeArr: string[]) => {
    const filteredPermissions = extractAllPermCodes(structuredPermission, codeArr)
    if (defaultPermission?.length !== codeArr?.length && codeArr?.length > 0) {
      setDefaultPermission(filteredPermissions);
    }

  };
  // end

  return (
    <div>
      <label className="inputs-label mb-2 fs-16 fw-600  secondary-color">
        {permissionHeading ?? "Store Permissions"}
      </label>
      <div className="member-permission">
        <CheckboxDropdown
          structuredPermission={structuredPermission}
          handleCheckboxChange={(codeArr: []) => _handleCheckboxChange(codeArr)}
          defaultPermission={defaultPermission}
        />
      </div>
    </div>
  );
};

export default AddStorePermission;
